import { z } from 'zod';

// Under the production CSP (no 'unsafe-eval') zod's probe of `new Function` is reported as a
// securitypolicyviolation even though it is caught. The probe runs when a schema is built,
// so this module is imported first in main.tsx, before @rnd/shared (T4.7 csp-smoke).
z.config({ jitless: true });
